import React from 'react';
import { Table } from 'reactstrap';
import Modal from '../../../shared/components/Modal/Modal';

// Modal genérico de detalhamento: recebe colunas ({key,label,align,format})
// e linhas já ordenadas pelo chamador (cada relatório decide a ordem certa).
const DetailModal = ({ isOpen, onClose, title, columns, rows }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} size="lg">
      {!rows || rows.length === 0 ? (
        <p className="text-muted mb-0">Nenhum item pra mostrar nesse período.</p>
      ) : (
        <div style={{ maxHeight: '60vh', overflowY: 'auto' }}>
          <Table hover responsive size="sm">
            <thead>
              <tr>
                {columns.map((col) => (
                  <th key={col.key} style={{ textAlign: col.align || 'left' }}>
                    {col.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((row, index) => (
                <tr key={row.id ?? index}>
                  {columns.map((col) => (
                    <td key={col.key} style={{ textAlign: col.align || 'left' }}>
                      {col.format ? col.format(row[col.key], row) : row[col.key]}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
    </Modal>
  );
};

export default DetailModal;
